import { h } from 'preact';
import styles from './CelebrationBanner.styles.css';
import ShadowWrapper from '../ShadowWrapper/ShadowWrapper.jsx';
import { useEffect, useState } from 'preact/hooks';

const CelebrationBanner = ({ isFulfilled, alreadyCelebrated, variant }) => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const fontsLink = document.querySelector('link[href="https://use.typekit.net/xid0xno.css"]');

    if (!fontsLink) {
      const link = document.createElement('link');
      link.href = 'https://use.typekit.net/xid0xno.css';
      link.rel = 'stylesheet';
      document.head.appendChild(link);

      return () => {
        document.head.removeChild(link);
      };
    }
  }, []);

  useEffect(() => {
    if (isFulfilled && !alreadyCelebrated) setIsShown(true);
  }, [isFulfilled, alreadyCelebrated]);

  if (!isFulfilled || alreadyCelebrated || !isShown) return null;

  const dispatchClose = (openModal = false) => {
    if (!openModal) setIsShown(false);
    window.dispatchEvent(new CustomEvent('celebration-banner-closed', { detail: { openModal } }));
  };

  return (
    <ShadowWrapper styles={styles}>
      <div className="celebration-banner-container">
        <img
          src="https://images.ctfassets.net/y3a9myzsdjan/2vQoUH4Q81PgwZi9CZEoL2/8404ef38fb05f5d78fc37c8294d94425/x.png"
          alt="Close"
          className="close-btn"
          onClick={() => dispatchClose(false)}
        />

        <div
          className={`celebration-banner ${
            variant === 'orange' ? 'orange-shadow' : variant === 'blue' ? 'blue-shadow' : ''
          }`}
          onClick={() => dispatchClose(true)}
          onTouchEnd={(e) => {
            e.preventDefault();
            dispatchClose(true);
          }}
        >
          <div className="text-info">
            <div className="text-info-title">YOU DID IT!</div>
            <div className="text-info-description">
              Incoming message from mission command.{' '}
              <span>
                WATCH NOW
                <img
                  src="https://images.ctfassets.net/y3a9myzsdjan/5cQwPsmR9nzkexJ65wsYgG/16603e162c4066903d2902410fe993b0/arrow-right.png"
                  alt=""
                />
              </span>
            </div>
          </div>
          <img
            src="https://images.ctfassets.net/y3a9myzsdjan/6Rmh1QCYVGtq1f3SRfkG6k/116f4db253acaff773f5aa9011a53a18/radial-gradient.png"
            alt=""
            className="radial-gradient"
          />
        </div>
      </div>
    </ShadowWrapper>
  );
};

export default CelebrationBanner;
